import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="15.207" height="15.207" viewBox="0 0 15.207 15.207">
      <g transform="translate(-4 -4)">
        <path
          d="M16.944,10.722A6.222,6.222,0,1,1,10.722,4.5,6.222,6.222,0,0,1,16.944,10.722Z"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M28.358,28.358l-3.383-3.383"
          transform="translate(-9.858 -9.858)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </SvgIcon>
  );
};
